import { CustomError } from './customError';

/**
 * Apiで予期せぬエラーの場合
 */
export class ApiResponseError extends CustomError { }
